import '../css/app.css'

import Alpine from 'alpinejs';

// Alpine.plugin(intersect);
Alpine.start();

// Vendor
import './vendor/swiper.js';
import './vendor/prism.js';
import './vendor/medium-zoom.js';
import './vendor/aos.js';


// Components
import './components/fanuc-product-renaming'
